import { Component, Inject, Input, Output, EventEmitter} from 'ng-metadata/core';
import {MendeleyService} from './mendeley.service';

@Component({
    selector: 'prm-mendeley',
    templateUrl: 'components/search/actions/mendeleyAction/mendeley.html',
})

export class PrmMendeley implements OnInit{
    @Output() closeTabsEvent = new EventEmitter<void>();
    
    constructor() {
    }

     ngOnInit() {
        this.closeTabsEvent.emit(null);
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/mendeleyAction/mendeley.directive.ts